import { mergeStyles, Stack } from '@fluentui/react';
import React, { useState } from 'react';
import BookMarkPaneComponent from '../../bookMarkPane/bookMarkPane';
import CollapseBookMarkPane from '../../collapseBookMarkPane/bookMarkPane';
import ProgressBar from '../../progressBar/progressBar';
import TitlePane from '../../titlePane/titlePane';
import { BookMarkItem } from '../../../types/template';
import { PMOL_TYPE } from '../../../types/projectMolecule';

const contentStyle = mergeStyles({
  height: 'calc(100vh - 25vh)!important',
  display: 'flex',
  flexDirection: 'column',
  selectors: {
    '@media(max-width: 1100px)': {
      width: '97.4%',
      height: 'calc(100vh)',
      position: 'absolute',
    },
  },
});

const listStyle = mergeStyles({
  flex: '1 1 auto',
  width: '100%',
  height: 'auto',
  overflowX: 'hidden',
  overflowY: 'auto',
  paddingBottom: '30px',
  marginLeft: '0',
});

const PMOLBookMarkPane = require('../../../components/projectMolecule/bookMarkPane/container').default;

const DocumentPaneSection = (props: {
  collapseBookmarkPane: boolean;
  showProgress: boolean;
  handleScroll: () => void;
  isEdit: boolean;
  bookmarkList: BookMarkItem[];
  currentActiveSection: string;
  children: any;
  renderCommandBar: any;
  formData: any;
  type?: number;
  isPMOL?: boolean;
  isRefresh?: boolean;
  renderAlert?: any
}) => {
  const [bookmarkDivClass, setBookmarkDivClass] = useState(
    'bookmark-panel parent',
  );

  const _toggleBookmark = (): void => {
    setBookmarkDivClass('bookmark-panel parent panel-on');
  };

  const _toggleBookmarkOut = (): void => {
    setBookmarkDivClass('bookmark-panel parent');
  };


  return (
    <div>
      <Stack
        className="project-list-header right-panel"
        style={{ backgroundColor: 'rgb(255, 255, 255)', paddingRight: 0 }}
        styles={{ root: { width: '100%', paddingRight: 0 } }}
      >
        <TitlePane
          close={true}
          isRefresh={props.isRefresh}
          headerTitle={
            props.formData ? props.formData.title : ''
          }
          collapse={true}
          isCollapse={props.collapseBookmarkPane}
          type={props.type}
        />
        {props.renderCommandBar()}
        <ProgressBar show={props.showProgress}/>
        {props?.renderAlert ? props?.renderAlert() : false}
      </Stack>

      <Stack
        className={`project-detail-list ${
          props.collapseBookmarkPane && screen.width > 1440
            ? 'full-inner-container'
            : 'inner-container'
        } cpc docPane  card-container`}
        styles={{
          root: {
            width: '100%',
            height: '76vh',
          },
        }}
      >
        { /* doc*/}
        <Stack
          className={contentStyle}
          horizontalAlign="start"
          verticalAlign="start"
          padding={0}
          gap={0}
          styles={{
            root: {
              width: '100%',
              height: '100%',
            },
          }}
        >
          <Stack
            className={listStyle}
            styles={{
              root: {
                width: '100%',
                height: 'auto',
              },
            }}
            verticalFill
            gap={50}
            horizontalAlign="start"
            verticalAlign="start"
            // onScroll={ props.handleScroll }
            onScroll={() => {
            }}
          >
            {props.children}
          </Stack>

          {props.collapseBookmarkPane && screen.width > 1440 ? (
            <CollapseBookMarkPane
              isEdit={props.isEdit}
              divClass={bookmarkDivClass}
              currentActiveSection={props.currentActiveSection}
              list={props.bookmarkList}
              toggleBookmark={_toggleBookmark}
              toggleBookmarkOut={_toggleBookmarkOut}
              pmolType={PMOL_TYPE.REGULAR}
            />
          ) : (
            !props.isPMOL ?
              <BookMarkPaneComponent
                isEdit={props.isEdit}
                divClass={bookmarkDivClass}
                currentActiveSection={props.currentActiveSection}
                list={props.bookmarkList}
                toggleBookmark={_toggleBookmark}
                toggleBookmarkOut={_toggleBookmarkOut}
              />
              :
              <PMOLBookMarkPane
                isEdit={props.isEdit}
                divClass={bookmarkDivClass}
                currentActiveSection={props.currentActiveSection}
                list={props.bookmarkList}
                toggleBookmark={_toggleBookmark}
                toggleBookmarkOut={_toggleBookmarkOut}
              />
          )}
        </Stack>
      </Stack>
    </div>
  );
};

export default DocumentPaneSection;
